import useChangeNotificationStatus from './useChangeNotificationStatus';

export default useChangeNotificationStatus;
export * from './useChangeNotificationStatus';
